<template>
  <section v-if="state.wholePartnersSectionShown" id="partneri"
           class="max-w-[1000px] md:mb-0 mb-[120px] md:mx-auto mx-[30px]">
    <div class="mx-[20px]">
      <div class="grid-cols-9 mt-12 md:mt-24 md:grid text-center">
        <div class="col-span-9 mt-[20px] mb-[18px]">
          <p class="font-medium uppercase text-[#2699C6] text-[16px] md:text-[32px]" style="line-height: normal">
            PARTNEŘI</p>
        </div>
        <div class="col-span-9">
          <p class="md:text-[56px] text-[28px] font-extrabold" style="line-height: normal;">
            Podporují nás ti nejlepší v oboru.
          </p>
        </div>
        <div class="col-span-9 flex justify-center mt-[60px]">
          <a href="mailto:sara@shopcamp.cz"
             class="font-semibold text-[20px] text-white px-[50px] py-[16px] bg-[#2699C6] rounded-full"
             style="line-height: normal">Chci být
            partner</a>
        </div>
      </div>
      <div class="relative">
        <div class="absolute bg-[#2699C6] w-full h-full z-[-1] opacity-50" style="filter: blur(514px);"></div>
        <div v-if="state.generalPartnersShown" class="grid-cols-9 gap-12 mt-12 md:mt-24 md:grid">
          <div class="col-span-9">
            <h3 class="md:text-left text-center font-semibold text-big-body text-[#2699C6]">Generální partneři
            </h3>
            <GeneralPartners :partners="state.generalPartners"></GeneralPartners>
          </div>
        </div>

        <div v-if="state.workLoungePartners && state.workLoungePartnersShown">
          <h3 class="md:text-left text-center font-semibold mt-9 text-big-body text-[#2699C6]">Partner worklounge</h3>
          <support-partners :partners="state.workLoungePartners"></support-partners>
        </div>

        <div v-if="state.afterPartyPartners && state.afterPartyPartnersShown">
          <h3 class="md:text-left text-center font-semibold mt-9 text-big-body text-[#2699C6]">Partner afterparty</h3>
          <support-partners :partners="state.afterPartyPartners"></support-partners>
        </div>

        <div v-if="state.mainPartnersShown">
          <h3 class="md:text-left text-center font-semibold mt-9 text-big-body text-[#2699C6]">Hlavní partneři</h3>
          <main-partners :partners="state.mainPartners"></main-partners>
        </div>


        <div v-if="state.partnersShown">
          <h3 class="md:text-left text-center font-semibold mt-9 text-big-body text-[#2699C6]">Partneři</h3>
          <partners :partners="state.partners"></partners>
        </div>

        <div v-if="state.supportPartnersShown">
          <h3 class="md:text-left text-center font-semibold mt-9 text-big-body text-[#2699C6]">Za podpory</h3>
          <support-partners :partners="state.supportPartners"></support-partners>
        </div>

        <div v-if="state.mediaPartnersShown">
          <h3 class="md:text-left text-center font-semibold mt-9 text-big-body text-[#2699C6]">Mediální partneři</h3>
          <medial-partners :partners="state.mediaPartners"></medial-partners>
        </div>
      </div>
    </div>
  </section>
</template>


<script setup>
import MainPartners from './GridTypes/MainPartners.vue';
import Partners from './GridTypes/Partners.vue';
import SupportPartners from './GridTypes/SupportPartners.vue';
import MedialPartners from './GridTypes/MedialPartners.vue';
import {usePartnersStore} from '../../stores/partners';
import GeneralPartners from "./GridTypes/GeneralPartners.vue";
import {useWindowSize} from "@vueuse/core";

const state = usePartnersStore();
const {width} = useWindowSize();
</script>
